import React from "react";
import { ArrowUpRight } from "lucide-react";
import bgImage from "../../../Assets/Images/Rental/football_bg.webp";
import { useNavigate } from "react-router-dom";

const HaveAQuestion = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/contact");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="flex justify-center w-full px-4 md:px-8 lg:px-12 mb-12">
      <div className="relative w-full rounded-2xl overflow-hidden py-12 sm:py-16 md:py-20 lg:py-24">
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${bgImage})`,
            transform: "scaleX(-1)",
          }}
        />
        <div className="absolute inset-0 bg-black/50" />

        {/* Content */}
        <div className="relative z-10 flex flex-col lg:flex-row items-center lg:items-end justify-center lg:justify-between h-full gap-10 text-center lg:text-left px-4 sm:px-8 md:px-12">
          {/* Heading */}
          <h2 className="text-white font-semibold leading-tight tracking-wide text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
            <span className="block">Have any</span>
            <span className="block mt-2">Questions...?</span>
          </h2>

          {/* Contact Button */}
          <div
            onClick={handleClick}
            className="flex flex-col items-center relative group cursor-pointer"
          >
            <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110 shadow-lg">
              <ArrowUpRight
                className="text-white w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-10 lg:h-10"
                strokeWidth={2.5}
              />
            </div>

            <div className="absolute -bottom-8 sm:-bottom-10 text-white font-semibold text-sm sm:text-base md:text-lg leading-tight">
              <p>Contact</p>
              {/* <p className="text-right">Us</p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HaveAQuestion;